export default {
  inserted(el, binding) {
    window.addEventListener('scroll', () => {
      if (el.getBoundingClientRect().top === 0) {
        binding.value.passed()
      } else {
        binding.value.unpassed()
      }
    })
  }
}
